import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import CustomStore from 'devextreme/data/custom_store';
import { Observable } from 'rxjs';
import { Utenteservice } from './utente.service';

export class PopulationByRegion {
  region: string;
  val: number;
}

export class AllDB {
  id:number;
  descrizione:string;
  alias?:string;
}


export class AllLicenzeInstallate {
  descrizione: string;
  stato?:string;
  idStato?:number;
  id?:string;
}

export class AllLicenze {
  descrizione: string;
  stato?:string;
  idStato?:number;
  codice?:string;
}

const allLicenze: AllLicenze[] = [
  {
    descrizione: 'CA001 - NICA SRL',
    stato:"Attiva",
    idStato:1,
    codice:"CA001"
}, 
{
  descrizione: 'CB001 - GESENU SRL',
  stato:"Attiva",
  idStato:1,
  codice:"CA001"
}, {
  descrizione: 'CA001 - PARTENOPE SRL',
  stato:"Sospesa",
  idStato:1,
  codice:"CA001"

}, {
  descrizione: 'CA001 - DI GENNARO SRL',
  stato:"In Attesa",
  idStato:1,
  codice:"CA001"

}, {
  descrizione: 'CA001 - VALLE UMBRA SRL',
  stato:"Attiva",
  idStato:1,
  codice:"CA001"

}, {
  descrizione: 'CA001 - PLANETARIA SRL',
  stato:"Attiva",
  idStato:1,
  codice:"CA001"

},  {
  descrizione: 'CA001 - NICA SRL',
  stato:"Attiva",
  idStato:1,
  codice:"CA001"
}, 
{
descrizione: 'CB001 - GESENU SRL',
stato:"Attiva",
idStato:1,
codice:"CA001"
}, {
descrizione: 'CA001 - PARTENOPE SRL',
stato:"Sospesa",
idStato:1,
codice:"CA001"

}, {
descrizione: 'CA001 - DI GENNARO SRL 555',
stato:"In Attesa",
idStato:1,
codice:"CA001"

}, {
descrizione: 'CA001 - VALLE UMBRA SRL 4444',
stato:"Attiva",
idStato:1,
codice:"CA001"

}, {
descrizione: 'CA001 - PLANETARIA SRL 222',
stato:"Attiva",
idStato:1,
codice:"CA001"

}];

const populationByRegions: PopulationByRegion[] = [{
  region: 'CA001 - NICA SRL',
  val: 4119626293,
}, {
  region: 'CA001 - GESENU SRL',
  val: 1012956064,
}, {
  region: 'CA001 - PARTENOPE SRL',
  val: 344124520,
}, {
  region: 'DI GENNARO SRL',
  val: 590946440,
}, {
  region: 'CA001 - VALLE UMBRA SRL',
  val: 727082222,
}, {
  region: 'CA001 - PLANETARIA SRL',
  val: 35104756,
},];


@Injectable({
  providedIn: 'root'
})
export class DatiService {

  constructor(public utenteService:Utenteservice, private http:HttpClient) { }


  
  getCustomSource(route){
    let myCs=null;

    myCs=new CustomStore({
      key: "id",
      load: () =>
        this.http.get('https://www.webrifiuti.it/api/index.php?azione=ReadTabella&table='+route
      ).toPromise(),
      insert: (values) => {
        let master={
          azione:"CRUD",
          tipo:"I",
          tabella:route,
          key:"id",
          keyvalue:0,
          data:values

        }
        return this.http.post('https://www.webrifiuti.it/api/index.php', master)
          .toPromise()
          ;
      }
      ,
      update: (key, values) => {

        let master={
           azione:"CRUD",
           tipo:"U",
           tabella:route,
           key:"id",
           keyvalue:key,
           data:values

        };


        return this.http.put('https://www.webrifiuti.it/api/index.php', master)
          .toPromise();
      }
      
    });

    return myCs;
   }
  async getSimpleArray(route){
      if (route==null) route='login';
      //let myResponse = new Observable((myObserver) =>{
       // myObserver.next(
         return this.http.get('https://www.webrifiuti.it/api/index.php?azione=ReadTabella&table='+route)
        .toPromise().then();


      }
     // )
     getPopulationByRegions(): PopulationByRegion[] {
      return populationByRegions;
     }
     getAllLicenze():AllLicenzeInstallate [] {
      /* 
      if(this.utenteService.InfoDatiUtenteConnesso.idtipoutente==1)
        return this.utenteService.InfoDatiUtenteConnesso.licenze.splice(1);
      else       return allLicenze;
      */
      if(this.utenteService.InfoUtenteConnesso.idtipoutente==1)
      return this.utenteService.InfoUtenteConnesso.licenze.splice(1);
    else       return this.utenteService.InfoUtenteConnesso.licenze;
     }


  }
//InfoUtenteConnesso
